<template>
    <section class="slice tag-page__footer">
        <div class="slice-content">
            <MktPagination v-if="nbPage > 1" class="tag-page__pagination" :current-page="pagination.current" :total-pages="nbPage" external />
            <div class="tag-page__footer-info">
                <div>{{ t('search.pager.title', [pagination.firstItem, pagination.lastItem, nbElements]) }}</div>
                <TagPageBreadcrumbs class="tag-page__footer-breadcrumbs" :tag="tag" />
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {ref} from 'vue';
    import {MktPagination} from '#components';
    import {useTranslation} from '#imports';
    import type {PaginationResponse} from '@api';
    import TagPageBreadcrumbs from './TagPageBreadcrumbs.vue';

    const {t} = useTranslation();

    const props = defineProps<{pagination: PaginationResponse; tag: string}>();

    const nbPage = ref(props.pagination.total);
    const nbElements = ref(props.pagination.totalElements);
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .tag-page {
        &__footer {
            &-info {
                @include mq.screen_md(min) {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
            }

            &-breadcrumbs {
                justify-content: center;
                margin-top: var(--joy-core-spacing-12);

                @include mq.screen_md(min) {
                    margin-top: 0;
                }
            }
        }

        &__pagination {
            display: flex;
            justify-content: center;
            margin-bottom: var(--joy-core-spacing-6);
        }
    }
</style>
